<template>
  <div>
    <h1 class="mb-7 font-roboto text-[26px] font-semibold leading-8">
      Справочник
    </h1>

    <WikiDictionaryFilters
      :default-letter="DEFAULT_LETTER"
      @change-letter="(val) => updateQueryParam('letter', val)"
      @submit-search="(val) => updateQueryParam('search', val)"
    />

    <div
      v-if="dictionaryData.length > 0"
      class="mt-6 grid grid-cols-1 md:grid-cols-3"
    >
      <NuxtLink
        v-for="item in dictionaryData"
        :key="item.id"
        :to="`/encyclopedia/${item.slug}`"
        class="group flex flex-col border-b border-[#F9F0F1] p-5 transition-colors hover:bg-new-gray-light/10"
      >
        <div class="flex items-center justify-between gap-2">
          <div
            class="text-gray-800 cursor-pointer text-[14px] font-bold uppercase tracking-wide transition-colors group-hover:text-specialprojectsection"
          >
            {{ item.title }}
          </div>
        </div>
      </NuxtLink>
    </div>

    <div v-else class="text-gray-400 py-16 text-center text-sm">
      В справочнике нет статей на эту букву или соответствующий поисковый запрос
    </div>

    <BaseThePagination class="mt-8" :entity="dictionary" />
  </div>
</template>

<script setup>
import api from '~~/services/api/api';

const DEFAULT_LETTER = 'А';

const router = useRouter();
const route = useRoute();

const updateQueryParam = (key, value) => {
  const nextQuery = { ...route.query };

  if (value === '') {
    delete nextQuery[key];
  } else {
    nextQuery[key] = value;
  }

  if (key === 'search' && value !== '') {
    delete nextQuery.letter;
  }
  if (key === 'letter') {
    delete nextQuery.search;
  }

  if (key !== 'page' && nextQuery.page) {
    delete nextQuery.page;
  }

  router.push({ path: route.path, query: nextQuery });
};

const dictionary = useAsyncData(
  'wiki-dictionary',
  async () => {
    const res = await api.wikis.getWikisDictionary({
      search: route.query.search || '',
      letter: route.query.search ? null : route.query.letter || DEFAULT_LETTER,
      page: Number(route.query.page) || 1,
    });
    return res?.data ?? { data: [] };
  },
  { watch: [() => route.query] },
);

const dictionaryData = computed(() => dictionary.data.value?.data ?? []);

const selectedLetter = computed(() =>
  route.query.search ? '' : route.query.letter || DEFAULT_LETTER,
);

const canonicalUrl = computed(() => {
  const query = new URLSearchParams();

  if (selectedLetter.value) query.set('letter', selectedLetter.value);
  if (route.query.page) query.set('page', route.query.page);

  const search = query.toString();

  return `${useHostApp()}${route.path}${search ? `?${search}` : ''}`;
});

useHead(() => ({
  title: `Алфавитный справочник${
    selectedLetter.value ? `: буква ${selectedLetter.value}` : ''
  } | Российская историческая энциклопедия | История РФ`,
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: `Алфавитный справочник Российской исторической энциклопедии${
        selectedLetter.value ? `, статьи на букву ${selectedLetter.value}` : ''
      }: личности, события и термины российской и мировой истории. Российское военно-историческое общество.`,
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
